export const SELECTED_TENANT = 'selected-tenant';
export const CSRF_TOKEN = 'web_csrf_token';
